import { useEffect } from 'react';
import { useAppDispatch } from '@/app/store';
import { handleSnackbar } from '@/shared/ui';

const QUERY_ERROR_SNACKBAR_DURATION = 3000;

export const useQueryErrorSnackbar = (
  error: unknown,
  fallbackMessage: string
) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!error) return;

    dispatch(
      handleSnackbar({
        open: true,
        message: error instanceof Error ? error.message : fallbackMessage,
        severity: 'error',
        autoHideDuration: QUERY_ERROR_SNACKBAR_DURATION,
      })
    );
  }, [dispatch, error, fallbackMessage]);
};
